<template>
  <div id="box" class="box">
    <template v-if="$route.query.inApp==5||$route.query.inApp==3?false:true">
      <transition name="fades">
        <app-header v-if="showHrader" :top0="true"></app-header>
      </transition>
    </template>
    <div class="imgBox1">
      <img class="backImg" src="https://res.jaadee.net/uploads/upgrade/articleVideo/20210323/01yblid7ex.jpeg"/>
      <img class="backBtn" src="../../assets/icons/width_left.svg" v-if="$route.query.inApp==5||$route.query.inApp==3?false:true" @click="back"/>
    </div>
    <div class="smallBox">
      <div class="lineBox">
        <p class="lineBoxP1"></p>
        <p class="lineBoxP2"></p>
        <p class="lineBoxP3"></p>
        <p class="lineBoxP4"></p>
        <div class="contentText">
          <span>“让所有珠宝玉石消费者不买假、不买错，构建一个客观公正的信赖体系”，</span>
          是我们翡翠王朝的矢志追求。翡翠王朝作为中国珠宝玉石首饰行业协会核心成员，云南省珠宝玉石文化促进会常务副会长单位，瑞丽市宝玉石协会副会长单位，自成立以来始终坚持立足源头，为广大翠友提供一手精品货源和源头精品宝玉石。<br/><br/>
          14年前，翡翠王朝就本着对消费者负责的准则，开创了玉石鉴别服务的先河，推出了7天自由退换货的服务，是消费者值得信赖、觉得可靠、买得放心的品牌。为确保货品质量，我们聘请以“东方珠宝教父”肖永福为代表的专家团队为我们的产品把关，并与国家珠宝玉石质量监督检验中心（NGTC）、广东GTC珠宝检测中心、云南质量技术监督局质检院、四川省珠宝检测院等权威检测机构长期合作。翡翠王朝每一件宝贝寄出前，均送国家认证资质的权威检测机构进行检测，并出具正规鉴定证书。<br/><br/>
          发展14年来，我们已为超过百万的顾客提供过优质服务，累计售出150多万件翡翠，未发现一件假货，获得省委书记点赞和百万粉丝信赖，被品牌行业促进会、民营企业家协会等多家单位联合评为良心品牌。
        </div>
      </div>
    </div>
    <div class="smallBox smallBox_top">
      <img class="biaoti1" src="../../assets/images/otherPage/identify/biaoti1.png"/>
      <div class="imgList">
        <div><img src="../../assets/images/otherPage/identify/feicui.png"/><p>翡翠</p></div>
        <div><img src="../../assets/images/otherPage/identify/hetianyu.png"/><p>和田玉</p></div>
        <div><img src="../../assets/images/otherPage/identify/hupomila.png"/><p>琥珀蜜蜡</p></div>
        <div><img src="../../assets/images/otherPage/identify/nanghon.png"/><p>南红</p></div>
        <div><img src="../../assets/images/otherPage/identify/caibao.png"/><p>彩宝</p></div>
        <div><img src="../../assets/images/otherPage/identify/qita.png"/><p>其他</p></div>
      </div>
      <div class="contentText" style="text-align: center;margin: .24rem;">所有在翡翠王朝购买的翡翠、和田玉、南红、琥珀蜜蜡、彩色宝石等在售珠宝玉石类成品 （不包括翡翠原石和其他未经加工的珠宝原材料， 也不包括搭配的配饰、活动赠品等附带品）</div>
    </div>
    <img class="biaoti2" src="../../assets/images/otherPage/identify/biaoti2.png"/>
    <img class="baozhang" src="../../assets/images/otherPage/identify/baozhang.png"/>
    <img class="yange" src="../../assets/images/otherPage/identify/yange.png"/>
    <img src="../../assets/images/otherPage/identify/bianzu6.png"/>
    <div class="smallBox smallBox_back">
      <img class="pingkong" src="../../assets/images/otherPage/identify/pingkong.png"/>
      <img src="../../assets/images/otherPage/identify/pingkon1.png"/>
      <div class="contentText text2">
        <span>1. 上手初审</span><br/>
        翡翠王朝专业资深货品专员上手鉴别货品大小、尺寸是否与图片描述一致，确保货品实物无破损。
      </div>
      <img src="../../assets/images/otherPage/identify/pingkon2.png"/>
      <div class="contentText text2">
        <span>2. 打灯检验</span><br/>
        通过反射光、透射光仔细查看货品结构、纹裂瑕疵，并如实记录，若货品纹裂瑕疵情况与商家描述差异较大，会进入售后服务保障流程由专人客服沟通。
      </div>
      <img src="../../assets/images/otherPage/identify/pingkon3.png"/>
    </div>
    <div class="smallBox smallBox_top smallBox_back">
      <img class="zhengshu1" src="../../assets/images/otherPage/identify/zhengshu1.png"/>
      <div class="contentText">
        翡翠王朝所售产品均经下列经国家认定资质的权威检测机构之一进行检测，并出具随货的检测证书。所有随货证书均可在出具报告的检验机构进行核实验证，确保您购买的是真品。
      </div>
      <img class="zhengshu2" src="../../assets/images/otherPage/identify/zhengshu2.png"/>
    </div>
    <div class="smallBox smallBox_top smallBox_back">
      <img class="mingdang1" src="../../assets/images/otherPage/identify/mingdang1.png"/>
      <div class="mList">
        <div>国家珠宝玉石质量监督检验中心</div>
        <p>证书查询地址：<a>http://www.ngtc.com.cn/</a></p>
      </div>
      <div class="mList">
        <div>中国地质大学珠宝检测中心</div>
        <p>证书查询地址：<a>www.gic.cug.edu.cn</a></p>
      </div>
      <div class="mList">
        <div>云南省珠宝玉石质量监督检验研究院</div>
        <p>证书查询地址：<a>www.giyn.net</a></p>
      </div>
      <div class="mList">
        <div>四川省珠宝玉石首饰产品质量监督检验中心</div>
        <p>证书查询地址：<a>www.cqi.org</a></p>
      </div>
      <div class="mList">
        <div>广东省技术监督珠宝贵金属质量检验站</div>
        <p>证书查询地址：<a>www.gtc-china.cn</a></p>
      </div>
      <div class="mList">
        <div>广东省质量监督金银珠宝检验站</div>
        <p>证书查询地址：<a>www.gdtc.cc</a></p>
      </div>
      <div class="mList">
        <div>国土资源部广州矿产资源监督检测中心</div>
        <p>证书查询地址：<a>www.gtzy123.com</a></p>
      </div>
    </div>
    <div class="smallBox smallBox_top smallBox_back">
      <img class="chengnuo" src="../../assets/images/otherPage/identify/chengnuo.png"/>
      <div class="lineBox">
        <p class="lineBoxP1"></p>
        <p class="lineBoxP2"></p>
        <p class="lineBoxP3"></p>
        <p class="lineBoxP4"></p>
        <div class="contentText">
          买家收到货品后，可选择上述任意一家检验机构进行复检（南红、和田玉、彩色宝石、琥珀蜜蜡等部分材质因为各地行业标准不一，需到原出具证书机构复检）。<br/>
          如复检鉴定结果（检验结论）与随货鉴定证书的鉴定结果（检验结论）不一致（不包括物理化学性状的优化处理，如烤色、加热、注胶等），翡翠王朝将针对该笔订单进行处理及赔偿，假一赔十。<br/>
          如客户复检结果（检验结论）存在物理化学性状的优化处理，翡翠王朝将针对该笔订单进行退款退货处理，退货过程产生的运费均由翡翠王朝承担。
        </div>
      </div>
    </div>
    <img class="wenti" src="../../assets/images/otherPage/identify/wenti.png"/>
    <img class="wenti_title" src="../../assets/images/otherPage/identify/bianzu7.png"/>
    <div class="left_line_box">
      <div class="left_line"></div>
      <div class="smallBox smallBox_left smallBox_back">
        <div class="contentText">
          复检证书鉴定结果（检验结论）与随货鉴定证书的鉴定结果（检验结论）不一致，凡是材质本身复检结果不是该类货品的都可称之为假货，如随货鉴定证书显示为翡翠的货品，复检结果明确排除翡翠的，则可视为假货处理；但对于行业标准不一致引起的歧义性结论，如将“南红”鉴定为“南红玛瑙”或“玛瑙”，则复检鉴定不构成假货的依据。构成假货的，翡翠王朝将按照约定针对该笔订单进行赔偿，按订单价赔偿十倍金额并收回货品。
        </div>
      </div>
    </div>
    <img class="wenti_title" src="../../assets/images/otherPage/identify/bianzu12.png"/>
    <div class="left_line_box">
      <div class="left_line"></div>
      <div class="smallBox smallBox_left smallBox_back">
        <div class="contentText">
          复检证书鉴定材质本身结果相同，但存在物理化学性状上的差异，如烤色、加热、注胶等优化处理情况，则不视为假货范畴，翡翠王朝将针对该笔订单进行退货退款处理，退货过程产生的费用均由翡翠王朝承担。
        </div>
      </div>
    </div>
    <img class="wenti_title" src="../../assets/images/otherPage/identify/bianzu13.png"/>
    <div class="left_line_box">
      <div class="smallBox smallBox_left smallBox_back">
        <div class="contentText">
          珠宝玉石从开采加工到销售的多个环节中，因为美化的需要，会经过一系列的优化处理，如加热、填充、烤色等优化处理的情形，常见的南红注胶、琥珀蜜蜡的烤色、宝石热处理和注油等处理。保真仅限于对物品材质类别的真假做鉴定，各类优化和问题均不在保真范围，不视为假货。<br/><br/>
          关于和田玉的皮色的补充说明：目前大多鉴定机构都不对和田玉皮色成因进行鉴定，所以和田玉皮色真假鉴定暂不在保真范围内！<br/><br/>
          若因国家、行业市场标准、检测机构鉴定标准发生变化，导致在以上鉴定机构无法出具复检证书或者证书鉴定结果（检验结论）与随货鉴定证书的鉴定结果（检验结论）不一致的，可联系平台客服进行申请处理。<br/>
          注：以上属特殊情形，均不能发起赔偿申请。<br/><br/>
          详见《保真承诺细则》<br/>
          <a class="url_promise">https://apph5.jaadee.com/page/#/about/promise</a>
        </div>
      </div>
    </div>
    <img class="shouhou" src="../../assets/images/otherPage/identify/shouhou.png"/>
    <div class="smallBox smallBox_back2">
      <img class="tuihuan" src="../../assets/images/otherPage/identify/tuihuan.png"/>
      <div class="lineBox">
        <p class="lineBoxP1"></p>
        <p class="lineBoxP2"></p>
        <p class="lineBoxP3"></p>
        <p class="lineBoxP4"></p>
        <div class="contentText">
          翡翠王朝14年来一直以专供超值好翡翠为经营方略，不仅开创了玉石鉴别服务，还坚持7天自由退换，赢得了500多万中高端客户的信赖和支持。区别于其他传统行业，只要是从翡翠王朝购买的珠宝产品，无论是一万、一百万、一千万，甚至上亿，自签收7天内，保证为您自由退换货，真正让您买的舒心、放心、安心！
        </div>
      </div>
      <div class="mList2">
        <div style="margin-left: -.12rem;">「不用担心买到假货」</div>
        <p>7天的时间里，您可以请所有权威专家帮您检测、辨别真假。</p>
      </div>
      <div class="mList2">
        <div style="margin-left: -.12rem;">「不用担心买贵」</div>
        <p>7天的时间里，您可以请所有的行家帮您反复估价。</p>
      </div>
      <div class="mList2">
        <div>不用担心没买对</div>
        <p>7天的时间里，您可以换上所有衣服搭配100遍，包您买到最适合的产品。</p>
      </div>
    </div>
    <div class="smallBox smallBox_back2 smallBox_top">
      <img class="peisong" src="../../assets/images/otherPage/identify/peisong.png"/>
      <div class="contentText contentText_color">
        <span>品质顺丰包邮 全程保价安心送</span><br/>
        您在翡翠王朝购买的所有货品会由顺丰速运全额保价寄出，国外及港澳台除外，确保产品万无一失的送到您手中。
      </div>
      <img class="shunfeng" src="../../assets/images/otherPage/identify/shunfeng.png"/>
      <div class="contentText contentText_color">
        <span>四层细致包装 精美安全两不误</span><br/>
        采用高强度防震/防压包装，每件货品经密封袋、防压防震膜、精致珠宝盒和品牌专属包装盒四层包装，确保产品到您手中时毫发无损。
      </div>
      <img class="baozhaung" src="../../assets/images/otherPage/identify/baozhaung.png"/>
    </div>
    <div class="smallBox smallBox_back2 smallBox_top">
      <img class="zhuanshukefu" src="../../assets/images/otherPage/identify/bianzu17.png"/>
      <div class="kefu_box">
        <div class="kefu_li">
          <img src="../../assets/images/otherPage/identify/kefu.png"/>
          <div>
            300多位客服实时在线<br/>
            用最专业的态度<br/>
            为您提供最贴心的服务
          </div>
        </div>
        <div class="kefu_li">
          <img src="../../assets/images/otherPage/identify/tuihuo.png"/>
          <div>
            退换货、产品保养<br/>
            等各种问题<br/>
            有一对一专属客服<br/>
            随时替您答疑解惑<br/>
            一站式解决您的所有需求
          </div>
        </div>
      </div>
    </div>
    <div class="smallBox smallBox_back2 smallBox_top">
      <img class="jianyi" src="../../assets/images/otherPage/identify/jianyi.png"/>
      <div class="contentText contentText_color">
        翡翠王朝14年以来，秉承“以客户开心为头等大事”的核心价值观，您每一条宝贵的建议都是我们前进的动力。<br/><br/>
        若您在体验中，有任何需要我们改进的地方，都可以通过简便、快捷的投诉建议通道给我们反馈，您提交成功的投诉建议将立刻通过企业微信的即时提醒功能，直达公司高管团队及售后/客诉服务中心，我们会认真对待您的每一条投诉/建议，保证不会让其石沉大海。
      </div>
      <img class="tousu" src="../../assets/images/otherPage/identify/tousu.png"/>
      <div class="contentText contentText_color" style="margin-bottom: .4rem;text-align: center;">
        您的建议我们定会虚心接受、更加努力，给翠友们带来更舒心的服务！
      </div>
    </div>
    <div :style="{'height': $route.query.inApp==5?'.8rem':'.2rem'}"></div>
    <img class="bottom_downapp" v-if="$route.query.inApp==5?false:false" @click="tt_download_app" src="../../assets/images/downapp.jpg"/>
  </div>
</template>

<script>
  import { setStatusTextColor } from '../../RNApp/index'
  import AppHeader from '../layouts/Header'
  import { inApp } from '../../config/index'
  import { vaptcha } from '../../assets/js/addtt'
  export default {
    name: "identify",
    components: { AppHeader },
    data () {
      return {
        showHrader: false
      }
    },
    watch: {
      showHrader: function (e) {
        if (e) { setStatusTextColor('black') } else { setStatusTextColor('white') }
      }
    },
    methods: {
      back() {
        if (!inApp()) {
          this.$router.go(-1);
          return true;
        }
        let params = {
          scene: "back",
        };
        window.ReactNativeWebView.postMessage(JSON.stringify(params));
      },
      tt_download_app () {
        tt.miniProgram.navigateTo({
          url: '/pages/fcwc/download/fcwc'
        })
      }
    },
    mounted () {
      const b = document.getElementById('box')
      b.addEventListener('scroll', () => {
        if (b.scrollTop > 60) { this.showHrader = true } else { this.showHrader = false }
      })
      if (this.$route.query.inApp == 5) {
        vaptcha()
      } else {
        setStatusTextColor('white')
      }
    }
  }
</script>

<style scoped>
  .box{background-color: #1A0E00;box-sizing: border-box;overflow-y: auto;height: 100vh;-webkit-overflow-scrolling: touch;}
  .smallBox{margin: 0 .15rem;padding: .15rem;background-color: #553823;border-radius:20px;}
  .smallBox_top{margin-top: .28rem;}
  .smallBox_left{margin-left: .5rem;}
  .smallBox_back{background-color: #4C3030;}
  .smallBox_back2{background-color: #4C3B30;}
  .lineBox{border: 1px solid #ddb383;position: relative;padding: .3rem .15rem;}
  .lineBox>p{width: 0;height: 0;border-radius: 20px;box-sizing: border-box;border-width: 10px;border-style: solid;border-color: transparent transparent #ddb383 transparent;position: absolute;}
  .lineBox>p:before{content:'';display: block;box-sizing: border-box;width: 0;height: 0;border-width: 9px;border-radius: 20px;border-style: solid;border-color: #553823;position: absolute;top: 50%;left: 50%;transform: translateX(-50%) translateY(-50%);}
  .lineBoxP1{top: -11px;left: -11px;transform: rotate(-45deg);}
  .lineBoxP2{top: -11px;right: -11px;transform: rotate(45deg);}
  .lineBoxP3{bottom: -11px;left: -11px;transform: rotate(-135deg);}
  .lineBoxP4{bottom: -11px;right: -11px;transform: rotate(135deg);}
  .contentText{color: #FFF3D7;font-size: .18rem;line-height: .3rem;font-weight: 100;text-align: justify;}
  .contentText>span{font-weight: 600;}
  .contentText_color>span{color: #FFC655;}
  .imgBox1{position: relative;}
  .backImg{width: 100%;}
  .backBtn{position: absolute;top: .6rem;left: .15rem;height: .4rem;}
  .biaoti1{height: .38rem;margin: .36rem 0 .16rem;}
  .imgList{display: flex;flex-flow: row wrap;align-items: center;justify-content: space-between;width: 95%;margin: 0 auto;}
  .imgList>div{width: .89rem;margin: .2rem .25rem;font-size: .16rem;color: #FFF3D7;font-weight: 400;}
  .imgList>div>p{margin-top: .1rem;}
  .biaoti2{height: .39rem;margin: .4rem 0 .24rem;}
  .baozhang{width: 4.7rem;margin-left: .04rem;}
  .yange{margin: .45rem 0 .2rem;height: .8rem;}
  .pingkong{height: .5rem;margin: .37rem 0 .26rem;}
  .text2{margin: .38rem 0 .16rem;}
  .text2>span{color: #FFC655;}
  .zhengshu1{height: .78rem;margin: .26rem 0 .24rem;}
  .zhengshu2{margin-top: .2rem;}
  .mingdang1{height: .75rem;margin: .31rem 0 .09rem;}
  .mList{height:0.64rem;background:linear-gradient(270deg,rgba(76,48,48,1) 0%,rgba(101,58,58,1) 100%);border-radius:0.1rem;display: flex;flex-flow: column nowrap;justify-content: center;text-align: left;padding-left: .21rem;}
  .mList>div{color: #fff;font-size:0.18rem;line-height:0.35rem;font-weight:500;}
  .mList>p{color: #999999;font-size:0.16rem;line-height:0.23rem;font-weight:400;}
  .mList>p>a{color: #F9EBB2;}
  .mList+.mList{margin-top: .09rem;}
  .chengnuo{height: .5rem;margin: .32rem 0 .2rem;}
  .wenti{height: .5rem;margin: .28rem 0 0;}
  .wenti_title{margin: .14rem .12rem;height: .28rem;display: block;}
  .left_line_box{display: flex;align-items: center;position: relative;}
  .left_line{position: absolute;width: 1px;height: 100%;background-color: #FFC655;left: .24rem;}
  .url_promise{color: #FFC655;}
  .shouhou{height: .38rem;margin: .48rem 0 .23rem;}
  .tuihuan{height: .5rem;margin: .21rem 0 .13rem;}
  .mList2{padding: .21rem;background:linear-gradient(270deg,rgba(76,59,48,1) 0%,rgba(133,99,76,1) 100%);border-radius:0.1rem;display: flex;flex-flow: column nowrap;justify-content: center;text-align: left;margin-top: .15rem;}
  .mList2>div{color: #FFC655;font-size: .2rem;line-height: .3rem;font-weight:500;}
  .mList2>p{color: #FFF3D7;font-size: .16rem;line-height: .23rem;font-weight:400;}
  .peisong{height: .55rem;margin: .35rem 0 .27rem;}
  .shunfeng{margin-top: .1rem;margin-bottom: .4rem;}
  .baozhaung{margin-top: .1rem;}
  .zhuanshukefu{height: .55rem;margin: .26rem 0 .34rem;}
  .kefu_box{display: flex;flex-flow: row nowrap;justify-content: space-between;}
  .kefu_li{width: 2.12rem;height: 2.93rem;background-color: #85634C;border-radius: .1rem;}
  .kefu_li>div{font-size:0.16rem;font-weight: 400;color: #FFF3D7;line-height:0.24rem;display: flex;justify-content: center;align-items: center;height: 1.5rem;}
  .jianyi{height: .55rem;margin: .33rem 0 .15rem;}
  .tousu{margin: .2rem 0;}
  .fades-enter-active,.fades-leave-active{transition: opacity .3s;}
  .fades-enter,.fades-leave-to{opacity: 0;}
  .bottom_downapp{position: fixed;bottom: 0;left: 0;}
</style>